<template>
  <div class="ProductItem">
    <div
      class="lists ImmediateBorrowing"
      data-type="0"
      :data-productid="productItemData.productId"
      @click="productClick"
    >
      <div class="page_body_content_box_top_fl openModel">
        {{ productItemData.productName }}

        <div class="circle">
          <img
            :src="productItemData.appLogoUrl"
            class="logo
            productNameImg"
          />
        </div>

        <img
          v-show="productItemData.recommend === 1"
          src="@/assets/images/recommand.png"
          class="recommand"
        />
      </div>
      <div
        class="page_body_content_box_middle ImmediateBorrowing"
        data-type="0"
      >
        <div class="page_body_content_box_middle_left">
          <p
            class="page_color_F55646 page_fontSize_39 page_fontB"
            style="margin: 0 0 8px 0"
          >
            <span class="font_colors">
              <span style="font-size: 12px">¥</span>
              {{ productItemData.maxAmount }}
            </span>
          </p>
          <p class="page_color_6A7388">
            最高额度(万元)
          </p>
        </div>
        <div class="page_body_content_box_middle_middle"></div>
        <div class="page_body_content_box_middle_right mgt_4 pd_6">
          <span class="line"> </span>
          <div class="style_rate">
            <p
              class="rate"
              style="margin: 0 0 8px 0"
            >
              {{ productItemData.rate }}
              <span style="font-size: 20px;">%</span>
              
            </p>  
            <p class="page_color_6A7388">
              最低{{ this.changeRate(productItemData.rateCategory) }}<span v-if="productItemData.rateDesc">({{productItemData.rateDesc}})</span>
            </p>
          </div>
          <span class="line"></span>
          <div class="theLast">
            <p
              style="margin: 0 0 8px 0"
              class="font_size"
            >
              <span class="time_font">
                {{ productItemData.repayTerm }}
              </span>
              <span style="margin-top: 7px;">
                个月
              </span>
            </p>
            <p class="page_color_6A7388">
              借款期限
            </p>
          </div>
        </div>
        <i class="iconfont icon-you "></i>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'ProductItem',
  data() {
    return {};
  },
  mounted() { },
  props: {
    productItemData: Object,
  },
  methods: {
    // 写一个方法changeRate，将利率传的值写成文字形式显示，
    // rateValue我们要传的值，其实到上面去就是productItemData.rateCategory
    changeRate(rateValue) {
      if (rateValue === '0') return '日利率';
      if (rateValue === '1') return '月利率';
      if (rateValue === '2') return '年利率';
      return '日利率'; // 当不是这些的时候，就显示日利率
    },
    productClick() {
      this.$router.push({
        path: '/supermarket/v2/productDetail',
        query: {
          productId: this.productItemData.productId,
        },
      });
    },
  },
};
</script>
<style scoped>
p {
  margin: 0;
}
.ProductItem {
  height: 124px;
  padding: 5px 15px;
}
.ProductItem .lists {
  position: relative;
  width: 100%;
  height: 100%;
  background: #ffffff;
  box-shadow: 0 7px 22px 4px rgba(206, 206, 206, 0.5);
  border-radius: 2px;
}
.ProductItem .lists .page_body_content_box_top_fl {
  font-size: 15px;
  height: 40px;
  line-height: 40px;
  font-family: PingFangSC-Medium;
  color: #495060;
  margin-bottom: 10px;
  padding-left: 45px;
  text-align: left;
  letter-spacing: 0;
  /* font-weight: bold; */
  position: relative;
}
.ProductItem .lists .page_body_content_box_top_fl .circle {
  width: 26px;
  height: 26px;
  border-radius: 50%;
  border: 1px solid #ececec;
  position: absolute;
  left: 10px;
  top: 5px;
  vertical-align: baseline;
}
.ProductItem .lists .page_body_content_box_top_fl .circle img {
  width: 26px;
  height: 26px;
  text-align: center;
}
.ProductItem .lists .page_body_content_box_middle {
  display: flex;
  padding: 0 15px 20px 15px;
}
.ProductItem .lists .page_body_content_box_middle .page_fontB {
  font-family: PingFangSC-Medium;
  font-size: 16px;
  color: #f55646;
  letter-spacing: 0;
  margin-bottom: 3px;
  text-align: center;
}
.ProductItem .lists .page_body_content_box_middle .page_fontB .font_colors {
  font-family: PingFangSC-Medium;
  font-size: 20px;
  color: #0079cc;
}

.page_color_6A7388 {
  font-family: PingFangSC-Regular;
  font-size: 12px;
  color: #b4b6b9;
  letter-spacing: 0;
  margin: 0;
}
.page_body_content_box_middle_middle {
  margin-left: 4px;
  margin-top: 34px;
}
.page_body_content_box_middle_right {
  box-sizing: border-box;
  position: absolute;
  left: 4px;
  display: flex;
  flex-direction: row;
  text-align: left;
}
.line {
  width: 1px;
  height: 54px;
  background: #d8d8d8;
  margin: 0 8px;
}
.style_rate {
  width: 80px;
  text-align: center;
}
.rate {
  margin: 0 0 3px 0;
  font-family: PingFangSC-Medium;
  font-size: 20px;
  color: #f55646;
}
.page_color_6A7388 {
  font-family: PingFangSC-Regular;
  font-size: 12px;
  color: #b4b6b9;
  letter-spacing: 0;
  padding-top: 5px;
}
.font_size {
  font-family: PingFangSC-Regular;
  font-size: 11px;
  color: #495060;
  display: flex;
  justify-content: left;
}
.time_font {
  font-family: PingFangSC-Medium;
  font-size: 20px;
  color: #242f4b;
  padding-right: 5px;
}
.recommand {
  position: absolute;
  right: 0;
  width: 46px;
  height: 46px;
}
.icon-you {
  position: absolute;
  right: 15px;
  top: 70px;
  color: #d8d8d8;
  display: inline-block;
  height: 10px;
  line-height: 10px;
  font-size: 25px;
}
.page_body_content_box_middle_left {
  width: 28%;
}
.page_body_content_box_middle_right {
  width: 63%;
  left: 29%;
}
.style_rate {
  width: 65%;
}
.theLast {
  width: 43%;
}
</style>
